export default (stylesUrl) => new Promise(done => {
    jQuery.get(stylesUrl)
    .then(css => {
        jQuery('head').append('<style id="ul-global-gnaas">' + css + "</style>")
        done()
    })
})